import {useEffect, useState} from 'react';
import dayjs from 'dayjs';

import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity} from 'ultra/configs/general';
import {getClientCityTimezone} from 'ultra/configs/general';
import {timestampToDate, getFormatedTime} from 'ultra/helpers/date'

import {useNavigationStore} from '../../../../../../../../Stores/navigation';
import {useConfigStore} from '../../../../../../../../Stores/config';

// import RecomendationDescriptionPreloader from '../../../../../../../../Components/RecomendationDescriptionPreloader'
import PreloaderText from '../../../../../../../../Components/Preloaders/PreloaderText';

import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import DefaultImage from '../../../../../../Widgets/DefaultImage'
import ContentImage from '../../../../../../Widgets/ContentImage'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import Gallery from '../../../../../../Widgets/Gallery';

import './index.scss';

function scamTitle(item) {
    let title = ''
    // telegram_id
    if (item.username) {
        title += '@' + item.username
    }
    if (item.telegram_id) {
        if (item.username) {
            title += ` (${item.telegram_id})`
        }
        else {
            title += item.telegram_id
        }
    }

    if (title.length === 0) {
        title += dayjs(new Date(timestampToDate(item._created))).format('YYYY-MM-DD HH:mm')
    }

    return title
}

export default function Template(props) {
    const {content, permits, config, breadcrumbs} = props

    const [timeZone, setTimeZone] = useState()

    const {contentLoading} = useNavigationStore()

    const {configs} = useConfigStore();

    useEffect(() => {
        const city = getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));
    }, [configs])

    return <div className='ScamTemplate'>
        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} title={scamTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {contentLoading && <PreloaderText />}

        {!contentLoading && <>
            {!content.thumbnail && !content.cover && <div className='DefaultPhoto'>
                <DefaultImage src="thumbnail" className='thumbnail'/>
            </div>}
            {content.thumbnail && <div className='TelegramPhoto'>
                <DefaultImage image={content.thumbnail} className='thumbnail'/>
            </div>}
            {content.cover && <div className='TelegramPhoto'>
                <ContentImage image={content.cover} className='thumbnail'/>
            </div>}

            {content.description && <div className='labelWrap labelWrapRow description'>
                <div className="label">Опис випадку:</div>
                <div className="labelValue">
                    <CKEditorContent content={content.description} />
                </div>
            </div>}

            {content.gallery && <div className='labelWrap labelWrapRow screenshots'>
                <div className="label">Скріншоти переписки:</div>
                <div className="labelValue"><Gallery content={content.gallery} zoom /></div>
            </div>}

            {content.telegram_id && <p className='labelWrap labelWrapRow'>
                <span className="label">TelegramID:</span>
                <span className="labelValue"><a href={`tg://user?id=${content.telegram_id}`}>{content.telegram_id}</a></span>
            </p>}

            {content.username && <p className='labelWrap labelWrapRow'>
                <span className="label">Username:</span>
                <span className="labelValue"><a href={`https://t.me/${content.username}`} target="_blank">@{content.username}</a></span>
            </p>}
            
            {content.cards && <p className='labelWrap labelWrapRow'>
                <span className="label">Використані картки:</span>
                <span className="labelValue">{content.cards.join(', ')}</span>
            </p>}

            {(content.delivery_pib || content.delivery_phone) && <p className='labelWrap labelWrapRow'>
                <span className="label">Дані що були вказані для доставки чи оплати:</span>
                {content.delivery_pib && <span className="labelValue">{content.delivery_pib}</span>}
                {content.delivery_phone && <span className="labelValue">{content.delivery_phone.code + content.delivery_phone.number}</span>}
            </p>}

            {content.username && <p className='labelWrap labelWrapRow'>
                <span className="label">Додано:</span>
                <span className="labelValue">{getFormatedTime(timestampToDate(content._created), timeZone)}</span>
            </p>}
        </>}
    </div>
}
